import {NotFound} from 'app/modules/errors/NotFound'
import {Outlet, Route, Routes} from 'react-router'

import SchoolWrapper from './components/SchoolWrapper'

const SchoolPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route path='/*' element={<SchoolWrapper />} />
      </Route>
      <Route index element={<NotFound />} />
    </Routes>
  )
}

export default SchoolPage
